export default "__VITE_ASSET__CWxqxNkU__"